import { Injectable } from '@angular/core';
import { IZone } from '../interfaces';
import { AbstractArchiveService } from './AbstractArchiveService';

@Injectable({
  providedIn: 'root'
})
export class ZonesService extends AbstractArchiveService<IZone> {
  protected readonly basePath = '/price-configuration/zones';
}
